import './assets/css/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

// 引入hui-mobile
import huiMobile from 'hui-mobile'
import 'hui-mobile/lib/hui-mobile.min.css'

// 按需引入hui-intl
import HuiIntl from 'hui-intl'
import 'hui-intl/lib/index.css'

// 自定义主题
import '@/assets/css/theme-color.css'
import { mobileCheck } from '@/lib/utils.js'

// 移动端使用工具修改 root的font-size
if (mobileCheck.isMobile) {
  import('amfe-flexible')
}

const app = createApp(App)

app.use(router)
app.use(huiMobile)
app.use(HuiIntl)
app.use(i18n)
app.mount('#app')

const { $createToast, $createPopup } = app.config.globalProperties
window.HM = {
  $createToast,
  $createPopup,
}
